<template>
  <div>
    <el-form :model="formData" label-width="200px" :rules="rules">
      <el-row>
        <el-form-item label="物件番号：">
          {{ formData.wujian_id }}
        </el-form-item>
        <el-form-item label="楼层：">
          {{formData.floor}}
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="addOneSplitFloors()">添加拆分楼层</el-button>
        </el-form-item>
      </el-row>

      <el-row v-for="item in formData.bataFloorList" :key="item.index" class="row">
        <el-form-item label="先行楼层：" prop="star">
          <el-select v-model="item.advance_floor" placeholder="先行楼层" style="width: 200px" clearable>
            <el-option v-for="dict in advanceFloorDataList" :key="dict.value" :label="dict.label" :value="dict.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="排产楼层：" prop="star">
          <el-input v-model="item.scheduling_floor" style="width: 200px;"></el-input>
        </el-form-item>
        <el-form-item label="关联批号：" prop="star">
          <el-select v-model="item.associated_batch_no" @change="renewBatchNoData()" placeholder="关联批号" multiple style="width: 600px" clearable>
            <el-option v-for="dict in batchFloorTempList" :key="dict.value" :label="dict.label" :value="dict.value"></el-option>
          </el-select>
        </el-form-item>
        <div style="margin-left: 5px" @click="removeOneSplitFloors(item.nanoid)">
            <el-icon color="red" size="26"><ElIconRemove /></el-icon>
        </div>
      </el-row>

<!--      <el-form-item label="展开结束：">-->
<!--        <el-date-picker v-model="formData.expand_end_date" type="date" style="width: 200px" format="YYYY-MM-DD" value-format="YYYY-MM-DD"/>-->
<!--      </el-form-item>-->

<!--      <el-row>-->
<!--        <el-form-item label="加工计划开始：">-->
<!--          <el-date-picker v-model="formData.jiagong_plan_start_date" type="date" style="width: 200px" format="YYYY-MM-DD" value-format="YYYY-MM-DD"/>-->
<!--        </el-form-item>-->
<!--        <el-form-item label="加工计划结束：">-->
<!--          <el-date-picker v-model="formData.jiagong_plan_end_date" type="date" style="width: 200px" format="YYYY-MM-DD" value-format="YYYY-MM-DD"/>-->
<!--        </el-form-item>-->
<!--      </el-row>-->

<!--      <el-row>-->
<!--        <el-form-item label="涂装计划开始：">-->
<!--          <el-date-picker v-model="formData.tuzhuang_plan_start_date" type="date" style="width: 200px" format="YYYY-MM-DD" value-format="YYYY-MM-DD"/>-->
<!--        </el-form-item>-->
<!--        <el-form-item label="涂装计划结束：">-->
<!--          <el-date-picker v-model="formData.tuzhuang_plan_end_date" type="date" style="width: 200px" format="YYYY-MM-DD" value-format="YYYY-MM-DD"/>-->
<!--        </el-form-item>-->
<!--      </el-row>-->

<!--      <el-row>-->
<!--        <el-form-item label="组立计划开始：">-->
<!--          <el-date-picker v-model="formData.zuli_plan_start_date" type="date" style="width: 200px" format="YYYY-MM-DD" value-format="YYYY-MM-DD"/>-->
<!--        </el-form-item>-->
<!--        <el-form-item label="组立计划结束：">-->
<!--          <el-date-picker v-model="formData.zuli_plan_end_date" type="date" style="width: 200px" format="YYYY-MM-DD" value-format="YYYY-MM-DD"/>-->
<!--        </el-form-item>-->
<!--      </el-row>-->

<!--      <el-row>-->
<!--        <el-form-item label="出荷：">-->
<!--          <el-date-picker v-model="formData.outbound_date" type="date" style="width: 200px" format="YYYY-MM-DD" value-format="YYYY-MM-DD"/>-->
<!--        </el-form-item>-->
<!--        <el-form-item label="搬入：">-->
<!--          <el-date-picker v-model="formData.move_in_date" type="date" style="width: 200px" format="YYYY-MM-DD" value-format="YYYY-MM-DD"/>-->
<!--        </el-form-item>-->
<!--      </el-row>-->

      <el-row>
        <el-form-item></el-form-item>
        <el-form-item>
          <el-button type="success" @click="submit" :loading="loading">提交</el-button>
        </el-form-item>
      </el-row>
    </el-form>

  </div>
</template>

<script>
import {nanoid} from 'nanoid'

export default {
  name: "MfgBatchFloorSplit",
  props: {
    parentData: {
      type: Object,
      default: () => {
        return {}
      }
    },
    setting: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {
      loading: false,
      formData: {
        wujian_id: '',
        floor: [],
        expand_end_date: '',
        jiagong_plan_start_date: '',
        jiagong_plan_end_date: '',
        tuzhuang_plan_start_date: '',
        tuzhuang_plan_end_date: '',
        zuli_plan_start_date: '',
        zuli_plan_end_date: '',
        outbound_date: '',
        move_in_date: '',
        bataFloorList: [],
      },
      advanceFloorDataList:[],
      batchFloorList: [],
      batchFloorTempList: [],
      dataEnd: [],

      rules: {
        star: [{required: true, message: '', trigger: 'red'}],
      },
    }
  },
  methods: {
    renewBatchNoData() {
      this.batchFloorTempList = this.batchFloorList.filter(item => {
        for (let obj of this.formData.bataFloorList) {
          if (obj.associated_batch_no && obj.associated_batch_no.includes(item.value)) {
            return false;
          }
        }
        return true;

      })

    },
    addFiveSplitFloors() {
      for (let i = 0; i < 1; i++) {
        this.formData.bataFloorList.push({
          nanoid: nanoid(),
        })
      }
    },
    addOneSplitFloors() {
      this.formData.bataFloorList.push({
        nanoid: nanoid(),
      })
    },
    removeOneSplitFloors(nanoid) {
      let index = this.formData.bataFloorList.findIndex(item => item.nanoid === nanoid);
      if (index == 0 ){
        return this.$message.error("第一个楼层拆分不能关闭！");
      }
      this.formData.bataFloorList.splice(index, 1);
    },
    getAdvanceFloor(){
      this.$axios.post('mfg/floor/getAdvanceFloor', this.formData).then(response => {
        let res = response.data
        this.advanceFloorDataList = res.data
      })
    },
    getFloorBatch() {

      this.formData.wujian_id = this.parentData.wujian_id
      this.formData.floor = this.parentData.floor
      this.formData.ids = this.parentData.ids
      if (!this.formData.wujian_id) {
        return this.$message.error('请先选择物件番号搜索!')
      }
      if (!this.formData.floor || this.formData.floor.length <= 0) {
        return this.$message.error('请先选择楼层搜索!')
      }else {
        this.formData.floor = JSON.stringify(this.parentData.floor).replace(/\[|]/g, '').replace(/\"|"/g, '')
      }
      if (this.formData.ids.length <= 0) {
        return this.$message.error('请勾选需要拆分楼层的数据!')
      }

      this.$axios.post('mfg/batch/getFloorBatch', this.formData).then(response => {
        let res = response.data
        if (res.code !== 0) {
          return this.$message.error(res.message);
        }

        this.batchFloorList = res.data
        this.batchFloorTempList = this.batchFloorList

      })
    },
    submit(){
      if (!this.formData.wujian_id) {
        return this.$message.error('请先选择物件番号搜索!')
      }
      if (!this.formData.floor || this.formData.floor.length <= 0) {
        return this.$message.error('请先选择楼层搜索!')
      }
      if (this.formData.ids.length <= 0) {
        return this.$message.error('请勾选需要拆分楼层的数据!')
      }

      for (let i = 0; i < this.formData.bataFloorList.length; i++) {
        let obj = this.formData.bataFloorList[i]
        if (!obj.advance_floor) {
          return this.$message.error(`第${i + 1}个先行楼层不能为空`);
        }
        if (!obj.scheduling_floor) {
          return this.$message.error(`第${i + 1}个排产楼层不能为空`);
        }
        if (obj.associated_batch_no.length <= 0) {
          return this.$message.error(`第${i + 1}个关联批号不能为空`);
        }
      }
      this.loading = true
      this.$axios.post('mfg/batch/editSchedulingFloor', this.formData).then(response => {
        let res = response.data
        if (res.code !== 0) {
          this.loading = false
          return this.$message.error(res.message);
        }
        this.loading = false
        this.setting.$fn.closeWindow();
        this.setting.$fn.reSearch();
        return this.$message.success('提交成功!');
      })
   },
  },created() {
    this.getFloorBatch()
    this.addFiveSplitFloors()
    this.getAdvanceFloor()
  }
}
</script>


<style scoped>
.close {
  position: absolute;
  top: 5px;
  right: 10px;
  font-size: 18px;
  cursor: pointer;
}

.row {
  /*border:1px solid black;*/
}

</style>